// Kariyer Online - Yeni Müfredat Yapısı
// Gramer + Havacılık + Kabin Memurluğu + Mülakat Entegre

export const KARIYER_LEVELS = {
  // ==================== SEVİYE 0: A0 - ABSOLUTE BEGINNER ====================
  level_0: {
    id: 'level_0',
    level_code: 'A0',
    title: 'Absolute Beginner',
    titleTr: 'Sıfırdan Başlangıç',
    description: 'İngilizce temel yapılar: Alfabe, sayılar, BE fiili, articles, zamirler',
    color: 'from-green-400 to-green-600',
    icon: '🌱',
    estimatedDays: 30,
    units: [
      {
        id: 1,
        unit_id: 'A0-U1',
        title: 'Alfabe, Sesler & Havacılık Alfabesi',
        description: 'İngilizce alfabesi, sesli harfler, NATO/ICAO fonetik alfabesi',
        lessons: [
          { id: 1, lesson_id: 'A0-U1-L1', title: 'İngilizce Alfabesi ve Telaffuz', type: 'grammar', duration: 15, xp: 30 },
          { id: 2, lesson_id: 'A0-U1-L2', title: 'Sesli Harfler (Vowels)', type: 'grammar', duration: 15, xp: 30 },
          { id: 3, lesson_id: 'A0-U1-L3', title: 'NATO/ICAO Fonetik Alfabesi', type: 'vocabulary', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'A0-U1-L4', title: 'Hece ve Vurgu (Syllables & Stress)', type: 'grammar', duration: 15, xp: 30 },
          { id: 5, lesson_id: 'A0-U1-L5', title: 'Uygulama: Uçuş Kodları', type: 'practice', duration: 20, xp: 40 },
          { id: 6, lesson_id: 'A0-U1-EXAM', title: 'Ünite 1 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 2,
        unit_id: 'A0-U2',
        title: 'Sayılar & Uçuş Bilgileri',
        description: 'Sayılar 1-100+, sıra sayıları, saat söyleme (24 saat sistemi)',
        lessons: [
          { id: 1, lesson_id: 'A0-U2-L1', title: 'Sayılar 1-20', type: 'grammar', duration: 15, xp: 30 },
          { id: 2, lesson_id: 'A0-U2-L2', title: 'Sayılar 21-100 ve Büyük Sayılar', type: 'grammar', duration: 15, xp: 30 },
          { id: 3, lesson_id: 'A0-U2-L3', title: 'Sıra Sayıları & Koltuk Numaraları', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'A0-U2-L4', title: 'Saat Söyleme - 24 Saat Sistemi', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'A0-U2-L5', title: 'Uygulama: Uçuş Bilgisi Verme', type: 'practice', duration: 20, xp: 40 },
          { id: 6, lesson_id: 'A0-U2-EXAM', title: 'Ünite 2 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 3,
        unit_id: 'A0-U3',
        title: 'BE Fiili (am/is/are)',
        description: 'BE fiilinin tüm formları: olumlu, olumsuz, soru yapısı',
        lessons: [
          { id: 1, lesson_id: 'A0-U3-L1', title: 'I am, You are, He/She/It is', type: 'grammar', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'A0-U3-L2', title: 'We are, They are', type: 'grammar', duration: 15, xp: 30 },
          { id: 3, lesson_id: 'A0-U3-L3', title: 'Olumsuz: am not, isn\'t, aren\'t', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'A0-U3-L4', title: 'Soru: Am I? Is he? Are they?', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'A0-U3-L5', title: 'Uygulama: Kendini Tanıtma', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'A0-U3-EXAM', title: 'Ünite 3 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 4,
        unit_id: 'A0-U4',
        title: 'Articles (a/an/the)',
        description: 'Belirsiz ve belirli artikeller, sayılabilir/sayılamaz isimler',
        lessons: [
          { id: 1, lesson_id: 'A0-U4-L1', title: 'A ve An Kullanımı', type: 'grammar', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'A0-U4-L2', title: 'THE Kullanımı', type: 'grammar', duration: 20, xp: 40 },
          { id: 3, lesson_id: 'A0-U4-L3', title: 'Artikel Kullanılmayan Durumlar', type: 'grammar', duration: 15, xp: 30 },
          { id: 4, lesson_id: 'A0-U4-L4', title: 'Sayılabilir vs Sayılamaz İsimler', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'A0-U4-L5', title: 'Uygulama: Uçak İçi Eşyalar', type: 'practice', duration: 20, xp: 40 },
          { id: 6, lesson_id: 'A0-U4-EXAM', title: 'Ünite 4 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 5,
        unit_id: 'A0-U5',
        title: 'Zamirler & Possessives',
        description: 'Subject, Object, Possessive pronouns ve demonstratives',
        lessons: [
          { id: 1, lesson_id: 'A0-U5-L1', title: 'Subject Pronouns (I, you, he...)', type: 'grammar', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'A0-U5-L2', title: 'Object Pronouns (me, you, him...)', type: 'grammar', duration: 20, xp: 40 },
          { id: 3, lesson_id: 'A0-U5-L3', title: 'Possessive Adjectives (my, your...)', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'A0-U5-L4', title: 'This, That, These, Those', type: 'grammar', duration: 15, xp: 30 },
          { id: 5, lesson_id: 'A0-U5-L5', title: 'Uygulama: Yolcu Eşyaları & Mülakat', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'A0-U5-EXAM', title: 'Ünite 5 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 6,
        unit_id: 'A0-FINAL',
        title: 'A0 Final Sınavı',
        description: 'Tüm A0 konularını kapsayan kapsamlı final sınavı',
        lessons: [
          { id: 1, lesson_id: 'A0-FINAL', title: 'A0 Seviye Final Sınavı', type: 'final_exam', duration: 45, xp: 200 }
        ]
      }
    ]
  },

  // ==================== SEVİYE 1: A1 - BEGINNER ====================
  level_1: {
    id: 'level_1',
    level_code: 'A1',
    title: 'Beginner',
    titleTr: 'Başlangıç',
    description: 'Present Simple, Can/Could, There is/are, Imperatives',
    color: 'from-blue-400 to-blue-600',
    icon: '📘',
    estimatedDays: 45,
    units: [
      {
        id: 1,
        unit_id: 'A1-U1',
        title: 'Present Simple - Olumlu',
        description: 'Geniş zaman olumlu yapı, frequency adverbs',
        lessons: [
          { id: 1, lesson_id: 'A1-U1-L1', title: 'I/You/We/They + fiil', type: 'grammar', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'A1-U1-L2', title: 'He/She/It + fiil + s/es', type: 'grammar', duration: 20, xp: 40 },
          { id: 3, lesson_id: 'A1-U1-L3', title: 'Spelling Rules (-s, -es, -ies)', type: 'grammar', duration: 15, xp: 30 },
          { id: 4, lesson_id: 'A1-U1-L4', title: 'Frequency Adverbs (always, never...)', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'A1-U1-L5', title: 'Uygulama: Kabin Memuru Rutini', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'A1-U1-EXAM', title: 'Ünite 1 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 2,
        unit_id: 'A1-U2',
        title: 'Present Simple - Olumsuz ve Soru',
        description: 'Don\'t/Doesn\'t, Do/Does ile soru yapma, WH sorular',
        lessons: [
          { id: 1, lesson_id: 'A1-U2-L1', title: 'I don\'t + fiil', type: 'grammar', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'A1-U2-L2', title: 'He/She doesn\'t + fiil', type: 'grammar', duration: 20, xp: 40 },
          { id: 3, lesson_id: 'A1-U2-L3', title: 'Do you...? Does she...?', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'A1-U2-L4', title: 'WH Sorular (What, Where, When...)', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'A1-U2-L5', title: 'Uygulama: Yolcuya Soru Sorma', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'A1-U2-EXAM', title: 'Ünite 2 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 3,
        unit_id: 'A1-U3',
        title: 'There is / There are',
        description: 'Var/yok yapıları, uçak özelliklerini anlatma',
        lessons: [
          { id: 1, lesson_id: 'A1-U3-L1', title: 'There is + tekil', type: 'grammar', duration: 15, xp: 30 },
          { id: 2, lesson_id: 'A1-U3-L2', title: 'There are + çoğul', type: 'grammar', duration: 15, xp: 30 },
          { id: 3, lesson_id: 'A1-U3-L3', title: 'There isn\'t / There aren\'t', type: 'grammar', duration: 15, xp: 30 },
          { id: 4, lesson_id: 'A1-U3-L4', title: 'Is there...? Are there...?', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'A1-U3-L5', title: 'Uygulama: Uçak Tanıtımı', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'A1-U3-EXAM', title: 'Ünite 3 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 4,
        unit_id: 'A1-U4',
        title: 'Can / Could (Yetenek ve Rica)',
        description: 'Yapabilmek, izin almak, nazik istekler',
        lessons: [
          { id: 1, lesson_id: 'A1-U4-L1', title: 'Can + fiil (yetenek)', type: 'grammar', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'A1-U4-L2', title: 'Can\'t + fiil (olumsuz)', type: 'grammar', duration: 15, xp: 30 },
          { id: 3, lesson_id: 'A1-U4-L3', title: 'Can I...? Can you...? (izin/rica)', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'A1-U4-L4', title: 'Could for Polite Requests', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'A1-U4-L5', title: 'Uygulama: Nazik İstekler', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'A1-U4-EXAM', title: 'Ünite 4 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 5,
        unit_id: 'A1-U5',
        title: 'Imperatives (Emir Cümleleri)',
        description: 'Olumlu/olumsuz emirler, güvenlik talimatları',
        lessons: [
          { id: 1, lesson_id: 'A1-U5-L1', title: 'Olumlu Emirler (Sit down, Listen)', type: 'grammar', duration: 15, xp: 30 },
          { id: 2, lesson_id: 'A1-U5-L2', title: 'Olumsuz Emirler (Don\'t...)', type: 'grammar', duration: 15, xp: 30 },
          { id: 3, lesson_id: 'A1-U5-L3', title: 'Nazik Emirler (Please...)', type: 'grammar', duration: 15, xp: 30 },
          { id: 4, lesson_id: 'A1-U5-L4', title: 'Let\'s... (Birlikte yapalım)', type: 'grammar', duration: 15, xp: 30 },
          { id: 5, lesson_id: 'A1-U5-L5', title: 'Uygulama: Güvenlik Anonsu', type: 'practice', duration: 30, xp: 60 },
          { id: 6, lesson_id: 'A1-U5-EXAM', title: 'Ünite 5 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 6,
        unit_id: 'A1-FINAL',
        title: 'A1 Final Sınavı & Mülakat',
        description: 'Kapsamlı final sınavı ve mini mülakat simülasyonu',
        lessons: [
          { id: 1, lesson_id: 'A1-FINAL', title: 'A1 Final Sınavı', type: 'final_exam', duration: 45, xp: 200 }
        ]
      }
    ]
  },

  // ==================== SEVİYE 2: A2 - ELEMENTARY ====================
  level_2: {
    id: 'level_2',
    level_code: 'A2',
    title: 'Elementary',
    titleTr: 'Temel',
    description: 'Past Simple, Present Continuous, Prepositions',
    color: 'from-yellow-400 to-yellow-600',
    icon: '📙',
    estimatedDays: 45,
    units: [
      {
        id: 1,
        unit_id: 'A2-U1',
        title: 'Past Simple - BE Fiili',
        description: 'Was/Were, wasn\'t/weren\'t, geçmiş zaman BE',
        lessons: [
          { id: 1, lesson_id: 'A2-U1-L1', title: 'Was / Were (olumlu)', type: 'grammar', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'A2-U1-L2', title: 'Wasn\'t / Weren\'t (olumsuz)', type: 'grammar', duration: 15, xp: 30 },
          { id: 3, lesson_id: 'A2-U1-L3', title: 'Was there...? Were there...?', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'A2-U1-L4', title: 'Time Expressions (yesterday, ago...)', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'A2-U1-L5', title: 'Uygulama: Uçuş Geçmişi', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'A2-U1-EXAM', title: 'Ünite 1 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 2,
        unit_id: 'A2-U2',
        title: 'Past Simple - Düzenli Fiiller',
        description: 'Fiil + ed kuralları, olumsuz ve soru',
        lessons: [
          { id: 1, lesson_id: 'A2-U2-L1', title: 'Fiil + ed (worked, played)', type: 'grammar', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'A2-U2-L2', title: 'Spelling Rules (-ed, -d, -ied)', type: 'grammar', duration: 20, xp: 40 },
          { id: 3, lesson_id: 'A2-U2-L3', title: 'Didn\'t + fiil (olumsuz)', type: 'grammar', duration: 15, xp: 30 },
          { id: 4, lesson_id: 'A2-U2-L4', title: 'Did...? (soru)', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'A2-U2-L5', title: 'Uygulama: Servis Anlatımı', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'A2-U2-EXAM', title: 'Ünite 2 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 3,
        unit_id: 'A2-U3',
        title: 'Past Simple - Düzensiz Fiiller',
        description: 'Irregular verbs: go-went, see-saw, fly-flew',
        lessons: [
          { id: 1, lesson_id: 'A2-U3-L1', title: 'Go-went, Come-came, Have-had, Do-did', type: 'grammar', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'A2-U3-L2', title: 'See-saw, Take-took, Give-gave, Get-got', type: 'grammar', duration: 20, xp: 40 },
          { id: 3, lesson_id: 'A2-U3-L3', title: 'Say-said, Tell-told, Make-made', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'A2-U3-L4', title: 'Fly-flew, Speak-spoke, Write-wrote', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'A2-U3-L5', title: 'Uygulama: Olay Anlatımı', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'A2-U3-EXAM', title: 'Ünite 3 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 4,
        unit_id: 'A2-U4',
        title: 'Present Continuous',
        description: 'Şimdiki zaman: am/is/are + fiil-ing',
        lessons: [
          { id: 1, lesson_id: 'A2-U4-L1', title: 'Am/Is/Are + fiil-ing', type: 'grammar', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'A2-U4-L2', title: 'Spelling Rules (-ing)', type: 'grammar', duration: 15, xp: 30 },
          { id: 3, lesson_id: 'A2-U4-L3', title: 'Olumsuz ve Soru', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'A2-U4-L4', title: 'Present Simple vs Continuous', type: 'grammar', duration: 25, xp: 50 },
          { id: 5, lesson_id: 'A2-U4-L5', title: 'Uygulama: Anlık Durum Raporu', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'A2-U4-EXAM', title: 'Ünite 4 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 5,
        unit_id: 'A2-U5',
        title: 'Prepositions (Edatlar)',
        description: 'Yer, zaman ve hareket edatları',
        lessons: [
          { id: 1, lesson_id: 'A2-U5-L1', title: 'Place: in, on, at, under, next to', type: 'grammar', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'A2-U5-L2', title: 'Time: at, on, in', type: 'grammar', duration: 20, xp: 40 },
          { id: 3, lesson_id: 'A2-U5-L3', title: 'Movement: to, from, into, through', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'A2-U5-L4', title: 'Other: for, with, by, about', type: 'grammar', duration: 15, xp: 30 },
          { id: 5, lesson_id: 'A2-U5-L5', title: 'Uygulama: Uçak İçi Yönlendirme', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'A2-U5-EXAM', title: 'Ünite 5 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 6,
        unit_id: 'A2-FINAL',
        title: 'A2 Final & Mülakat Pratiği',
        description: 'Kapsamlı final sınavı ve mülakat pratiği',
        lessons: [
          { id: 1, lesson_id: 'A2-FINAL', title: 'A2 Final Sınavı', type: 'final_exam', duration: 45, xp: 200 }
        ]
      }
    ]
  },

  // ==================== SEVİYE 3: B1 - INTERMEDIATE ====================
  level_3: {
    id: 'level_3',
    level_code: 'B1',
    title: 'Intermediate',
    titleTr: 'Orta',
    description: 'Future tenses, Comparatives, First Conditional, Modal Verbs',
    color: 'from-orange-400 to-orange-600',
    icon: '📕',
    estimatedDays: 45,
    units: [
      {
        id: 1,
        unit_id: 'B1-U1',
        title: 'Future - Will',
        description: 'Will + fiil, offers, promises, predictions',
        lessons: [
          { id: 1, lesson_id: 'B1-U1-L1', title: 'Will + fiil (olumlu)', type: 'grammar', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'B1-U1-L2', title: 'Won\'t + fiil (olumsuz)', type: 'grammar', duration: 15, xp: 30 },
          { id: 3, lesson_id: 'B1-U1-L3', title: 'Will...? (soru)', type: 'grammar', duration: 15, xp: 30 },
          { id: 4, lesson_id: 'B1-U1-L4', title: 'Uses: Offers, Promises, Predictions', type: 'grammar', duration: 25, xp: 50 },
          { id: 5, lesson_id: 'B1-U1-L5', title: 'Uygulama: Anonslar ve Vaatler', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'B1-U1-EXAM', title: 'Ünite 1 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 2,
        unit_id: 'B1-U2',
        title: 'Future - Going to',
        description: 'Be going to + fiil, planlar vs tahminler',
        lessons: [
          { id: 1, lesson_id: 'B1-U2-L1', title: 'Am/Is/Are going to + fiil', type: 'grammar', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'B1-U2-L2', title: 'Will vs Going to', type: 'grammar', duration: 25, xp: 50 },
          { id: 3, lesson_id: 'B1-U2-L3', title: 'Olumsuz ve Soru', type: 'grammar', duration: 15, xp: 30 },
          { id: 4, lesson_id: 'B1-U2-L4', title: 'Evidence-based Predictions', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'B1-U2-L5', title: 'Uygulama: Uçuş Planı', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'B1-U2-EXAM', title: 'Ünite 2 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 3,
        unit_id: 'B1-U3',
        title: 'Comparatives & Superlatives',
        description: 'Karşılaştırma: bigger, more comfortable, the best',
        lessons: [
          { id: 1, lesson_id: 'B1-U3-L1', title: 'Short Adjectives: -er, -est', type: 'grammar', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'B1-U3-L2', title: 'Long Adjectives: more, most', type: 'grammar', duration: 20, xp: 40 },
          { id: 3, lesson_id: 'B1-U3-L3', title: 'Irregular: good-better-best', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'B1-U3-L4', title: 'As...as, not as...as', type: 'grammar', duration: 15, xp: 30 },
          { id: 5, lesson_id: 'B1-U3-L5', title: 'Uygulama: Hizmet Karşılaştırma', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'B1-U3-EXAM', title: 'Ünite 3 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 4,
        unit_id: 'B1-U4',
        title: 'First Conditional',
        description: 'If + present, will + fiil (gerçek olasılıklar)',
        lessons: [
          { id: 1, lesson_id: 'B1-U4-L1', title: 'If + Present Simple, will + fiil', type: 'grammar', duration: 25, xp: 50 },
          { id: 2, lesson_id: 'B1-U4-L2', title: 'Unless = If not', type: 'grammar', duration: 15, xp: 30 },
          { id: 3, lesson_id: 'B1-U4-L3', title: 'When, As soon as, Before, After', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'B1-U4-L4', title: 'Real Possibilities', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'B1-U4-L5', title: 'Uygulama: Koşullu Bilgilendirme', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'B1-U4-EXAM', title: 'Ünite 4 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 5,
        unit_id: 'B1-U5',
        title: 'Modal Verbs: Obligation & Advice',
        description: 'Must, Have to, Should, Need to',
        lessons: [
          { id: 1, lesson_id: 'B1-U5-L1', title: 'Must / Mustn\'t (zorunluluk)', type: 'grammar', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'B1-U5-L2', title: 'Have to / Don\'t have to', type: 'grammar', duration: 20, xp: 40 },
          { id: 3, lesson_id: 'B1-U5-L3', title: 'Should / Shouldn\'t (tavsiye)', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'B1-U5-L4', title: 'Need to / Don\'t need to', type: 'grammar', duration: 15, xp: 30 },
          { id: 5, lesson_id: 'B1-U5-L5', title: 'Uygulama: Kural ve Tavsiye', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'B1-U5-EXAM', title: 'Ünite 5 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 6,
        unit_id: 'B1-FINAL',
        title: 'B1 Final & Mülakat Simülasyonu',
        description: 'Tam mülakat pratiği: motivasyon, gelecek planları',
        lessons: [
          { id: 1, lesson_id: 'B1-FINAL', title: 'B1 Final Sınavı', type: 'final_exam', duration: 45, xp: 200 }
        ]
      }
    ]
  },

  // ==================== SEVİYE 4: B1-INT - B1 MÜLAKAT EĞİTİMİ ====================
  level_4: {
    id: 'level_4',
    level_code: 'B1-INT',
    title: 'B1 Interview Training',
    titleTr: 'B1 Mülakat Eğitimi',
    description: 'Kabin memurluğu mülakat hazırlığı - B1 seviyesi sorular ve örnekler',
    color: 'from-teal-400 to-teal-600',
    icon: '🎯',
    estimatedDays: 20,
    units: [
      {
        id: 1,
        unit_id: 'B1INT-U1',
        title: 'Temel Mülakat Soruları',
        description: 'Daha önce çıkmış temel sorular ve örnek cevaplar',
        lessons: [
          { id: 1, lesson_id: 'B1INT-U1-L1', title: 'Tell me about yourself', type: 'interview', duration: 25, xp: 50 },
          { id: 2, lesson_id: 'B1INT-U1-L2', title: 'Why do you want to be a cabin crew?', type: 'interview', duration: 25, xp: 50 },
          { id: 3, lesson_id: 'B1INT-U1-L3', title: 'Why our airline?', type: 'interview', duration: 25, xp: 50 },
          { id: 4, lesson_id: 'B1INT-U1-L4', title: 'What are your strengths and weaknesses?', type: 'interview', duration: 30, xp: 60 },
          { id: 5, lesson_id: 'B1INT-U1-L5', title: 'Pratik: Kendini Tanıtma', type: 'practice', duration: 30, xp: 60 },
          { id: 6, lesson_id: 'B1INT-U1-EXAM', title: 'Ünite 1 Sınavı', type: 'exam', duration: 20, xp: 50 }
        ]
      },
      {
        id: 2,
        unit_id: 'B1INT-U2',
        title: 'Deneyim ve Motivasyon Soruları',
        description: 'Customer service deneyimi ve motivasyon soruları',
        lessons: [
          { id: 1, lesson_id: 'B1INT-U2-L1', title: 'Describe your customer service experience', type: 'interview', duration: 25, xp: 50 },
          { id: 2, lesson_id: 'B1INT-U2-L2', title: 'How do you handle difficult customers?', type: 'interview', duration: 30, xp: 60 },
          { id: 3, lesson_id: 'B1INT-U2-L3', title: 'What do you know about our company?', type: 'interview', duration: 25, xp: 50 },
          { id: 4, lesson_id: 'B1INT-U2-L4', title: 'Where do you see yourself in 5 years?', type: 'interview', duration: 25, xp: 50 },
          { id: 5, lesson_id: 'B1INT-U2-L5', title: 'Pratik: Deneyim Anlatma', type: 'practice', duration: 30, xp: 60 },
          { id: 6, lesson_id: 'B1INT-U2-EXAM', title: 'Ünite 2 Sınavı', type: 'exam', duration: 20, xp: 50 }
        ]
      },
      {
        id: 3,
        unit_id: 'B1INT-U3',
        title: 'Mini Mülakat Simülasyonu',
        description: 'Tam mülakat simülasyonu ve değerlendirme',
        lessons: [
          { id: 1, lesson_id: 'B1INT-U3-L1', title: 'Mülakat Simülasyonu - Bölüm 1', type: 'simulation', duration: 30, xp: 60 },
          { id: 2, lesson_id: 'B1INT-U3-L2', title: 'Mülakat Simülasyonu - Bölüm 2', type: 'simulation', duration: 30, xp: 60 },
          { id: 3, lesson_id: 'B1INT-U3-EXAM', title: 'B1 Mülakat Final', type: 'final_exam', duration: 40, xp: 100 }
        ]
      }
    ]
  },

  // ==================== SEVİYE 5: B2 - UPPER-INTERMEDIATE ====================
  level_5: {
    id: 'level_5',
    level_code: 'B2',
    title: 'Upper-Intermediate',
    titleTr: 'Üst Orta',
    description: 'Present Perfect, Past Continuous, Second Conditional, Passive, Reported Speech',
    color: 'from-purple-400 to-purple-600',
    icon: '📗',
    estimatedDays: 45,
    units: [
      {
        id: 1,
        unit_id: 'B2-U1',
        title: 'Present Perfect',
        description: 'Have/Has + past participle, ever, never, for, since',
        lessons: [
          { id: 1, lesson_id: 'B2-U1-L1', title: 'Have/Has + Past Participle', type: 'grammar', duration: 25, xp: 50 },
          { id: 2, lesson_id: 'B2-U1-L2', title: 'Ever, Never, Already, Yet, Just', type: 'grammar', duration: 20, xp: 40 },
          { id: 3, lesson_id: 'B2-U1-L3', title: 'For vs Since', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'B2-U1-L4', title: 'Present Perfect vs Past Simple', type: 'grammar', duration: 25, xp: 50 },
          { id: 5, lesson_id: 'B2-U1-L5', title: 'Uygulama: Deneyim Anlatma', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'B2-U1-EXAM', title: 'Ünite 1 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 2,
        unit_id: 'B2-U2',
        title: 'Past Continuous',
        description: 'Was/Were + -ing, while vs when',
        lessons: [
          { id: 1, lesson_id: 'B2-U2-L1', title: 'Was/Were + fiil-ing', type: 'grammar', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'B2-U2-L2', title: 'While vs When', type: 'grammar', duration: 20, xp: 40 },
          { id: 3, lesson_id: 'B2-U2-L3', title: 'Past Continuous vs Past Simple', type: 'grammar', duration: 25, xp: 50 },
          { id: 4, lesson_id: 'B2-U2-L4', title: 'Interrupted Actions', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'B2-U2-L5', title: 'Uygulama: Olay Raporu', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'B2-U2-EXAM', title: 'Ünite 2 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 3,
        unit_id: 'B2-U3',
        title: 'Second Conditional',
        description: 'If + past, would + fiil (varsayımsal durumlar)',
        lessons: [
          { id: 1, lesson_id: 'B2-U3-L1', title: 'If + Past Simple, Would + fiil', type: 'grammar', duration: 25, xp: 50 },
          { id: 2, lesson_id: 'B2-U3-L2', title: 'Unreal/Hypothetical Situations', type: 'grammar', duration: 20, xp: 40 },
          { id: 3, lesson_id: 'B2-U3-L3', title: 'Could/Might instead of Would', type: 'grammar', duration: 15, xp: 30 },
          { id: 4, lesson_id: 'B2-U3-L4', title: 'If I were you, I would...', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'B2-U3-L5', title: 'Uygulama: Mülakat Senaryoları', type: 'practice', duration: 30, xp: 60 },
          { id: 6, lesson_id: 'B2-U3-EXAM', title: 'Ünite 3 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 4,
        unit_id: 'B2-U4',
        title: 'Passive Voice',
        description: 'Edilgen yapı: is served, was delayed, will be announced',
        lessons: [
          { id: 1, lesson_id: 'B2-U4-L1', title: 'Present Passive (is/are + V3)', type: 'grammar', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'B2-U4-L2', title: 'Past Passive (was/were + V3)', type: 'grammar', duration: 20, xp: 40 },
          { id: 3, lesson_id: 'B2-U4-L3', title: 'Future Passive (will be + V3)', type: 'grammar', duration: 15, xp: 30 },
          { id: 4, lesson_id: 'B2-U4-L4', title: 'Passive with Modals', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'B2-U4-L5', title: 'Uygulama: Prosedür Anlatımı', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'B2-U4-EXAM', title: 'Ünite 4 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 5,
        unit_id: 'B2-U5',
        title: 'Reported Speech',
        description: 'Dolaylı anlatım: He said, She asked, He told me',
        lessons: [
          { id: 1, lesson_id: 'B2-U5-L1', title: 'Say vs Tell', type: 'grammar', duration: 15, xp: 30 },
          { id: 2, lesson_id: 'B2-U5-L2', title: 'Reporting Statements', type: 'grammar', duration: 25, xp: 50 },
          { id: 3, lesson_id: 'B2-U5-L3', title: 'Reporting Questions', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'B2-U5-L4', title: 'Reporting Commands', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'B2-U5-L5', title: 'Uygulama: Bilgi Aktarma', type: 'practice', duration: 25, xp: 50 },
          { id: 6, lesson_id: 'B2-U5-EXAM', title: 'Ünite 5 Sınavı', type: 'exam', duration: 15, xp: 50 }
        ]
      },
      {
        id: 6,
        unit_id: 'B2-FINAL',
        title: 'B2 Final & STAR Method',
        description: 'Competency-based interview, STAR method pratiği',
        lessons: [
          { id: 1, lesson_id: 'B2-FINAL', title: 'B2 Final Sınavı', type: 'final_exam', duration: 60, xp: 250 }
        ]
      }
    ]
  },

  // ==================== SEVİYE 6: B2-INT - B2 MÜLAKAT EĞİTİMİ ====================
  level_6: {
    id: 'level_6',
    level_code: 'B2-INT',
    title: 'B2 Interview Training',
    titleTr: 'B2 Mülakat Eğitimi',
    description: 'İleri mülakat hazırlığı - B2 seviyesi situational ve behavioral sorular',
    color: 'from-orange-400 to-orange-600',
    icon: '🎤',
    estimatedDays: 25,
    units: [
      {
        id: 1,
        unit_id: 'B2INT-U1',
        title: 'Behavioral Sorular (STAR Metodu)',
        description: 'Geçmiş deneyim soruları ve STAR tekniği',
        lessons: [
          { id: 1, lesson_id: 'B2INT-U1-L1', title: 'STAR Method Nedir?', type: 'theory', duration: 20, xp: 40 },
          { id: 2, lesson_id: 'B2INT-U1-L2', title: 'Tell me about a time you dealt with a difficult situation', type: 'interview', duration: 30, xp: 60 },
          { id: 3, lesson_id: 'B2INT-U1-L3', title: 'Describe a time you worked in a team', type: 'interview', duration: 30, xp: 60 },
          { id: 4, lesson_id: 'B2INT-U1-L4', title: 'Give an example of when you went above and beyond', type: 'interview', duration: 30, xp: 60 },
          { id: 5, lesson_id: 'B2INT-U1-L5', title: 'Pratik: STAR Cevapları Hazırlama', type: 'practice', duration: 35, xp: 70 },
          { id: 6, lesson_id: 'B2INT-U1-EXAM', title: 'Ünite 1 Sınavı', type: 'exam', duration: 25, xp: 60 }
        ]
      },
      {
        id: 2,
        unit_id: 'B2INT-U2',
        title: 'Situational Sorular',
        description: 'Senaryo bazlı sorular ve problem çözme',
        lessons: [
          { id: 1, lesson_id: 'B2INT-U2-L1', title: 'What would you do if a passenger refused to fasten seatbelt?', type: 'interview', duration: 30, xp: 60 },
          { id: 2, lesson_id: 'B2INT-U2-L2', title: 'How would you handle a medical emergency?', type: 'interview', duration: 30, xp: 60 },
          { id: 3, lesson_id: 'B2INT-U2-L3', title: 'What if two passengers were arguing?', type: 'interview', duration: 30, xp: 60 },
          { id: 4, lesson_id: 'B2INT-U2-L4', title: 'What if a colleague was not doing their job?', type: 'interview', duration: 30, xp: 60 },
          { id: 5, lesson_id: 'B2INT-U2-L5', title: 'Pratik: Senaryo Çözümleme', type: 'practice', duration: 35, xp: 70 },
          { id: 6, lesson_id: 'B2INT-U2-EXAM', title: 'Ünite 2 Sınavı', type: 'exam', duration: 25, xp: 60 }
        ]
      },
      {
        id: 3,
        unit_id: 'B2INT-U3',
        title: 'Grup Mülakat ve Assessment',
        description: 'Grup aktiviteleri, role-play ve assessment center',
        lessons: [
          { id: 1, lesson_id: 'B2INT-U3-L1', title: 'Grup Tartışması Stratejileri', type: 'theory', duration: 25, xp: 50 },
          { id: 2, lesson_id: 'B2INT-U3-L2', title: 'Role-Play Senaryoları', type: 'simulation', duration: 35, xp: 70 },
          { id: 3, lesson_id: 'B2INT-U3-L3', title: 'Assessment Center Tips', type: 'theory', duration: 25, xp: 50 },
          { id: 4, lesson_id: 'B2INT-U3-L4', title: 'Pratik: Grup Simülasyonu', type: 'simulation', duration: 40, xp: 80 },
          { id: 5, lesson_id: 'B2INT-U3-EXAM', title: 'B2 Mülakat Final', type: 'final_exam', duration: 45, xp: 120 }
        ]
      }
    ]
  },

  // ==================== SEVİYE 7: C1 - ADVANCED ====================
  level_7: {
    id: 'level_7',
    level_code: 'C1',
    title: 'Advanced',
    titleTr: 'İleri',
    description: 'Perfect Tenses Advanced, Third Conditional, Advanced Modals, Complex Sentences',
    color: 'from-red-400 to-red-600',
    icon: '📓',
    estimatedDays: 45,
    units: [
      {
        id: 1,
        unit_id: 'C1-U1',
        title: 'Perfect Tenses Advanced',
        description: 'Present Perfect Continuous, Past Perfect, Future Perfect',
        lessons: [
          { id: 1, lesson_id: 'C1-U1-L1', title: 'Present Perfect Continuous', type: 'grammar', duration: 25, xp: 50 },
          { id: 2, lesson_id: 'C1-U1-L2', title: 'Past Perfect', type: 'grammar', duration: 25, xp: 50 },
          { id: 3, lesson_id: 'C1-U1-L3', title: 'Past Perfect Continuous', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'C1-U1-L4', title: 'Future Perfect', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'C1-U1-L5', title: 'Uygulama: Profesyonel Anonslar', type: 'practice', duration: 30, xp: 60 },
          { id: 6, lesson_id: 'C1-U1-EXAM', title: 'Ünite 1 Sınavı', type: 'exam', duration: 20, xp: 60 }
        ]
      },
      {
        id: 2,
        unit_id: 'C1-U2',
        title: 'Third Conditional',
        description: 'If + past perfect, would have + V3 (geçmiş pişmanlıklar)',
        lessons: [
          { id: 1, lesson_id: 'C1-U2-L1', title: 'If + Past Perfect, Would have + V3', type: 'grammar', duration: 30, xp: 60 },
          { id: 2, lesson_id: 'C1-U2-L2', title: 'Regrets About the Past', type: 'grammar', duration: 20, xp: 40 },
          { id: 3, lesson_id: 'C1-U2-L3', title: 'Mixed Conditionals', type: 'grammar', duration: 25, xp: 50 },
          { id: 4, lesson_id: 'C1-U2-L4', title: 'Wish + Past Perfect', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'C1-U2-L5', title: 'Uygulama: Olay Analizi', type: 'practice', duration: 30, xp: 60 },
          { id: 6, lesson_id: 'C1-U2-EXAM', title: 'Ünite 2 Sınavı', type: 'exam', duration: 20, xp: 60 }
        ]
      },
      {
        id: 3,
        unit_id: 'C1-U3',
        title: 'Advanced Modal Verbs',
        description: 'Must have, Should have, Could have (geçmiş çıkarım/pişmanlık)',
        lessons: [
          { id: 1, lesson_id: 'C1-U3-L1', title: 'Must have / Can\'t have (çıkarım)', type: 'grammar', duration: 25, xp: 50 },
          { id: 2, lesson_id: 'C1-U3-L2', title: 'Should have / Shouldn\'t have (pişmanlık)', type: 'grammar', duration: 25, xp: 50 },
          { id: 3, lesson_id: 'C1-U3-L3', title: 'Could have / Might have (olasılık)', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'C1-U3-L4', title: 'Would rather / Had better', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'C1-U3-L5', title: 'Uygulama: Kriz Analizi', type: 'practice', duration: 30, xp: 60 },
          { id: 6, lesson_id: 'C1-U3-EXAM', title: 'Ünite 3 Sınavı', type: 'exam', duration: 20, xp: 60 }
        ]
      },
      {
        id: 4,
        unit_id: 'C1-U4',
        title: 'Complex Sentences & Report Writing',
        description: 'Relative clauses, participle clauses, formal linking',
        lessons: [
          { id: 1, lesson_id: 'C1-U4-L1', title: 'Relative Clauses (who, which, that)', type: 'grammar', duration: 25, xp: 50 },
          { id: 2, lesson_id: 'C1-U4-L2', title: 'Participle Clauses (-ing, -ed)', type: 'grammar', duration: 25, xp: 50 },
          { id: 3, lesson_id: 'C1-U4-L3', title: 'Inversion for Emphasis', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'C1-U4-L4', title: 'Formal Linking Words', type: 'grammar', duration: 20, xp: 40 },
          { id: 5, lesson_id: 'C1-U4-L5', title: 'Uygulama: Profesyonel Rapor', type: 'practice', duration: 35, xp: 70 },
          { id: 6, lesson_id: 'C1-U4-EXAM', title: 'Ünite 4 Sınavı', type: 'exam', duration: 20, xp: 60 }
        ]
      },
      {
        id: 5,
        unit_id: 'C1-U5',
        title: 'Professional Communication Mastery',
        description: 'De-escalation, diplomatic expressions, cross-cultural communication',
        lessons: [
          { id: 1, lesson_id: 'C1-U5-L1', title: 'De-escalation Language', type: 'speaking', duration: 30, xp: 60 },
          { id: 2, lesson_id: 'C1-U5-L2', title: 'Diplomatic Expressions', type: 'speaking', duration: 25, xp: 50 },
          { id: 3, lesson_id: 'C1-U5-L3', title: 'Formal vs Informal Register', type: 'grammar', duration: 20, xp: 40 },
          { id: 4, lesson_id: 'C1-U5-L4', title: 'Cross-Cultural Communication', type: 'speaking', duration: 25, xp: 50 },
          { id: 5, lesson_id: 'C1-U5-L5', title: 'Uygulama: Zor Yolcu Yönetimi', type: 'practice', duration: 35, xp: 70 },
          { id: 6, lesson_id: 'C1-U5-EXAM', title: 'Ünite 5 Sınavı', type: 'exam', duration: 25, xp: 70 }
        ]
      },
      {
        id: 6,
        unit_id: 'C1-FINAL',
        title: 'C1 Final & Profesyonel Mülakat',
        description: 'Kapsamlı gramer, rapor yazma, tam mülakat simülasyonu',
        lessons: [
          { id: 1, lesson_id: 'C1-FINAL', title: 'C1 Final Sınavı', type: 'final_exam', duration: 60, xp: 300 }
        ]
      }
    ]
  },

  // ==================== SEVİYE 8: C1-INT - C1 MÜLAKAT EĞİTİMİ ====================
  level_8: {
    id: 'level_8',
    level_code: 'C1-INT',
    title: 'C1 Interview Training',
    titleTr: 'C1 Mülakat Eğitimi',
    description: 'Profesyonel mülakat - C1 seviyesi karmaşık sorular ve ileri teknikler',
    color: 'from-rose-400 to-rose-600',
    icon: '🏆',
    estimatedDays: 30,
    units: [
      {
        id: 1,
        unit_id: 'C1INT-U1',
        title: 'İleri Behavioral Sorular',
        description: 'Karmaşık durum ve liderlik soruları',
        lessons: [
          { id: 1, lesson_id: 'C1INT-U1-L1', title: 'Describe a time you showed leadership', type: 'interview', duration: 30, xp: 60 },
          { id: 2, lesson_id: 'C1INT-U1-L2', title: 'Tell me about a time you failed and what you learned', type: 'interview', duration: 30, xp: 60 },
          { id: 3, lesson_id: 'C1INT-U1-L3', title: 'How do you prioritize under pressure?', type: 'interview', duration: 30, xp: 60 },
          { id: 4, lesson_id: 'C1INT-U1-L4', title: 'Describe your biggest professional achievement', type: 'interview', duration: 30, xp: 60 },
          { id: 5, lesson_id: 'C1INT-U1-L5', title: 'Pratik: Liderlik Örnekleri', type: 'practice', duration: 35, xp: 70 },
          { id: 6, lesson_id: 'C1INT-U1-EXAM', title: 'Ünite 1 Sınavı', type: 'exam', duration: 25, xp: 60 }
        ]
      },
      {
        id: 2,
        unit_id: 'C1INT-U2',
        title: 'Havayolu Spesifik Sorular',
        description: 'Şirkete özel araştırma ve stratejik cevaplar',
        lessons: [
          { id: 1, lesson_id: 'C1INT-U2-L1', title: 'Turkish Airlines Hakkında', type: 'theory', duration: 25, xp: 50 },
          { id: 2, lesson_id: 'C1INT-U2-L2', title: 'Emirates/Etihad/Qatar Hakkında', type: 'theory', duration: 25, xp: 50 },
          { id: 3, lesson_id: 'C1INT-U2-L3', title: 'European Airlines (Lufthansa, BA, AF)', type: 'theory', duration: 25, xp: 50 },
          { id: 4, lesson_id: 'C1INT-U2-L4', title: 'What sets you apart from other candidates?', type: 'interview', duration: 30, xp: 60 },
          { id: 5, lesson_id: 'C1INT-U2-L5', title: 'Pratik: Şirket Araştırma', type: 'practice', duration: 35, xp: 70 },
          { id: 6, lesson_id: 'C1INT-U2-EXAM', title: 'Ünite 2 Sınavı', type: 'exam', duration: 25, xp: 60 }
        ]
      },
      {
        id: 3,
        unit_id: 'C1INT-U3',
        title: 'Final Interview ve Panel',
        description: 'Final mülakat, panel interview ve video interview',
        lessons: [
          { id: 1, lesson_id: 'C1INT-U3-L1', title: 'Panel Interview Stratejileri', type: 'theory', duration: 25, xp: 50 },
          { id: 2, lesson_id: 'C1INT-U3-L2', title: 'Video Interview Tips', type: 'theory', duration: 25, xp: 50 },
          { id: 3, lesson_id: 'C1INT-U3-L3', title: 'Final Round Hazırlık', type: 'practice', duration: 30, xp: 60 },
          { id: 4, lesson_id: 'C1INT-U3-L4', title: 'Tam Mülakat Simülasyonu', type: 'simulation', duration: 45, xp: 90 },
          { id: 5, lesson_id: 'C1INT-U3-EXAM', title: 'C1 Mülakat Final', type: 'final_exam', duration: 50, xp: 150 }
        ]
      }
    ]
  },

  // CCT (Cabin Crew Training) modülü kaldırıldı - kullanıcı talebi
  // Kabin memurluğu eğitimi içerikleri mevcut seviyelere entegre edilmiştir
};

// Yardımcı fonksiyonlar
export const getAllLevels = () => Object.values(KARIYER_LEVELS);

export const getLevel = (levelId) => {
  const key = levelId?.toString().startsWith('level_') ? levelId : `level_${levelId}`;
  return KARIYER_LEVELS[key];
};

export const getLevelUnits = (levelId) => {
  const key = levelId?.toString().startsWith('level_') ? levelId : `level_${levelId}`;
  return KARIYER_LEVELS[key]?.units || [];
};

export const getUnit = (levelId, unitId) => {
  const key = levelId?.toString().startsWith('level_') ? levelId : `level_${levelId}`;
  const level = KARIYER_LEVELS[key];
  return level?.units?.find(u => u.id === parseInt(unitId));
};

export const getLesson = (levelId, unitId, lessonId) => {
  const unit = getUnit(levelId, unitId);
  return unit?.lessons?.find(l => l.id === parseInt(lessonId));
};

export const getTotalStats = () => {
  let totalLessons = 0;
  let totalMiles = 0;
  let totalMinutes = 0;
  
  Object.values(KARIYER_LEVELS).forEach(level => {
    level.units.forEach(unit => {
      unit.lessons.forEach(lesson => {
        totalLessons++;
        totalMiles += lesson.miles || 0;
        totalMinutes += lesson.duration || 0;
      });
    });
  });
  
  return { totalLessons, totalMiles, totalMinutes };
};

// Placement test sonucuna göre açılacak seviyeleri belirle
export const getUnlockedLevelsByPlacement = (placementResult) => {
  // placementResult: 'A0', 'A1', 'A2', 'B1', 'B2', 'C1'
  // Yeni sıralama: A0(0), A1(1), A2(2), B1(3), B1-INT(4), B2(5), B2-INT(6), C1(7), C1-INT(8)
  const levelMapping = {
    'A0': ['level_0'],
    'A1': ['level_0', 'level_1'],
    'A2': ['level_0', 'level_1', 'level_2'],
    'B1': ['level_0', 'level_1', 'level_2', 'level_3', 'level_4'], // B1 + B1-INT
    'B2': ['level_0', 'level_1', 'level_2', 'level_3', 'level_4', 'level_5', 'level_6'], // B2 + B1-INT + B2-INT
    'C1': ['level_0', 'level_1', 'level_2', 'level_3', 'level_4', 'level_5', 'level_6', 'level_7', 'level_8'] // C1 + tüm INT
  };
  
  return levelMapping[placementResult] || ['level_0'];
};

// Modülün herkese açık olup olmadığını kontrol et
export const isPublicModule = (levelId) => {
  const level = getLevel(levelId);
  return level?.isPublic === true;
};

// İleri mülakat modüllerinin kullanılabilir olup olmadığını kontrol et
export const isAdvancedModuleAvailable = (userProgress) => {
  // Artık kullanılmıyor - getUnlockedLevelsByPlacement kullan
  return true;
};

export default KARIYER_LEVELS;
